/**
 * The owl at a staff wait: `@ruby/owl/react`'s `OwlWait` with the wait timing
 * wired once, so no host reports anything itself. Use it where a spinner or a
 * loading line sat in a content area; buttons keep their own small spinners.
 *
 * Plan: docs/plans/2026-10-22-owl-waits-everywhere.md (staff screens)
 */
import { OwlWait, type OwlWaitProps } from '@ruby/owl/react';
import { reportWait } from '../lib/wait-timing';

/** Sends nothing while signed out, judged when the wait ends (`reportWait`). */
export function HqOwlWait(props: Omit<OwlWaitProps, 'onEnd'>) {
  return <OwlWait {...props} onEnd={reportWait} />;
}
